// The current state of a transaction that is still in progress as displayed to the user.
const CloverTransactionState = Object.freeze({
    ATTEMPTING_TO_CANCEL: 'Attempting To Cancel',
    ATTEMPTING_TO_REFUND: 'Attempting To Refund',
    ATTEMPTING_TO_VOID: 'Attempting To Void',
    CHECKING_DUPLICATE_CARD: 'Duplicate Payment Check',
    CHECKING_PARTIAL_PAYMENT: 'Insufficient Funds Check',
    CHECKING_PAYMENT_STATUS: 'Checking Payment Status',
    CHECKING_SIGNATURE: 'Checking Signature',
    IN_PROGRESS: 'In Progress',
    WAITING_FOR_GRATUITY: 'Waiting For Gratuity',
});

module.exports = CloverTransactionState;
